<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon>
        <span>Importar Grupo de Solução</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-select
              id="group-solution-select"
              v-model="payload.grupoSolucao"
              item-text="nome"
              item-value="municipioGrupoSolucaoId"
              :items="groupSolutionList"
              label="Grupo de Solução"
              placeholder="Grupo de Solução"
              :return-object="true"
              @change="changeGroupSolution"
            >
              <template slot="no-data">
                Nenhum Grupo de Solução retornado
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-combobox
              v-model="grupoSolucao"
              :items="solucoes"
              chips
              clearable
              label="Soluções"
              item-text="nome"
              item-value="solucaoId"
              multiple
              :disabled="!payload.grupoSolucao.grupoSolucaoId"
            >
              <template slot="no-data">
                Nenhuma Solução retornada
              </template>
            </v-combobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { groupSolutionAPI } from "../../API/GroupSolutionAPI";
import { cityGroupSolutionAPI } from "@/modules/city";
import { mapActions } from "vuex";

export default {
  name: "AppModalImportGroupSolution",
  props: {
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        grupoSolucao: {
          solucoes: []
        }
      },
      grupoSolucao: [],
      dialog: false,
      groupSolutionList: [],
      solucoes: [],
      allSolutions: []
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      const variables = {
        ...this.payload,
        grupoSolucao: {
          grupoSolucaoId: this.payload.grupoSolucaoId,
          grupoSolucaoProjetos: [],
          nome: this.payload.nome,
          solucoes: this.grupoSolucao
        }
      };
      cityGroupSolutionAPI
        .create(variables)
        .then(resp => {
          this.setLoading(false);
          this.$notification.success("Grupo de Solução incluído com sucesso");
          this.dialog = false;
          this.$emit("onSave");
          this.getGroupSolution();
        })
        .catch(resp => {
          this.setLoading(false);
          this.$notification.error("Erro ao incluir grupo de solução");
        });
    },
    changeGroupSolution() {
      this.payload.grupoSolucaoId = this.payload.grupoSolucao.grupoSolucaoId;
      this.payload.nome = this.payload.grupoSolucao.nome;
      this.payload.descricao = this.payload.grupoSolucao.descricao;
      this.solucoes = this.allSolutions.filter(
        item => item.grupoSolucaoId === this.payload.grupoSolucaoId
      )[0].solucoes;
      this.grupoSolucao = this.solucoes;
    },
    getGroupSolution() {
      groupSolutionAPI
        .listNotInCity(this.$route.params.id)
        .then(resp => {
          this.allSolutions = resp.data;
          this.groupSolutionList = resp.data;
        })
        .catch();
    }
  },
  mounted() {
    this.getGroupSolution();
  }
};
</script>
